<template>
  <div class="floating-window" :class="{ 'collapsed': isCollapsed }">
    <!-- 悬浮窗头部 -->
    <div class="floating-header" @click="toggleCollapse">
      <div class="title-vertical">
        <template v-if="isCollapsed">
          <span>下</span>
          <span>载</span>
          <span>A</span>
          <span>P</span>
          <span>P</span>
          <span class="triangle">◀</span>
        </template>
        <template v-else>
          <span class="horizontal-text">收起</span>
        </template>
      </div>
    </div>
    
    <!-- 悬浮窗内容 -->
    <div class="floating-content" v-show="!isCollapsed">
      <slot>
        <p>扫描二维码下载APP</p>
        <div class="qr-code-placeholder">
          <img src="@/assets/img/玲珑商城app1.1.0二维码.png" alt="玲珑商城APP二维码" class="qr-code-image" />
        </div>
        <button class="floating-btn" @click="handleAction">立即下载</button>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FloatingWindow',
  props: {
    title: {
      type: String,
      default: '下载APP'
    },
    position: {
      type: String,
      default: 'right', // right, left
      validator: value => ['right', 'left'].includes(value)
    }
  },
  data() {
    return {
      isCollapsed: true // 默认关闭
    }
  },
  mounted() {
    // 添加全局点击事件监听
    document.addEventListener('click', this.handleGlobalClick);
  },
  beforeUnmount() {
    // 移除全局点击事件监听
    document.removeEventListener('click', this.handleGlobalClick);
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    handleGlobalClick(event) {
      // 如果点击的不是悬浮窗本身，则收起悬浮窗
      const floatingWindow = this.$el;
      if (floatingWindow && !floatingWindow.contains(event.target)) {
        this.isCollapsed = true;
      }
    },
    handleAction() {
      // 打开APK下载链接
      window.open('https://bizai-1257935629.cos.ap-beijing.myqcloud.com/LlApkMg/apk/app_version/d6b55167efdb4d11826c6b3b4d5a3f5f.apk', '_blank');
      this.$emit('action');
    }
  }
}
</script>

<style scoped>
.floating-window {
  position: fixed;
  right: 20px;
  top: 60%;
  transform: translateY(-50%);
  width: 200px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
  overflow: hidden;
}

.floating-window.left {
  right: auto;
  left: 20px;
}

  .floating-window.collapsed {
    width: 40px;
  }

.floating-header {
  display: flex !important;
  justify-content: center !important; /* 居中对齐 */
  align-items: center !important;
  padding: 12px 16px !important;
  background: #76b900 !important; /* 主题色 */
  color: white !important;
  cursor: pointer !important;
  user-select: none !important;
}

.title-vertical {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
  height: 70px; /* 增加高度以容纳三角图标 */
  justify-content: center;
  width: 100%; /* 确保占满整个宽度 */
}

.title-vertical:has(.horizontal-text) {
  height: 10px; /* 展开状态下减少高度 */
}

.title-vertical span {
  font-size: 12px;
  font-weight: 600;
  color: white;
  margin: 0;
  display: block;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
  text-align: center; /* 确保文字居中 */
}

.triangle {
  font-size: 10px;
  color: white;
  transition: transform 0.3s ease;
  display: block; /* 改为block确保独占一行 */
  margin-top: 4px;
  text-align: center; /* 确保三角图标居中 */
}

.triangle.rotated {
  transform: rotate(-90deg);
}

.horizontal-text {
  font-size: 10px;
  font-weight: 500;
  color: white;
  display: block;
  text-align: center;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
  line-height: 1;
  margin: 0;
}

.floating-content {
  padding: 16px; /* 减少内边距 */
}

.floating-content p {
  margin: 0 0 12px 0;
  color: #6b7280;
  line-height: 1.5;
  text-align: center;
  font-size: 13px; /* 减少字体大小 */
}

.qr-code-placeholder {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
}

.qr-code-image {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
}

.floating-btn {
  background: #76b900; /* 主题色 */
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background 0.2s ease;
  width: 100%;
}

.floating-btn:hover {
  background: #5a8c00; /* 主题色的深色版本 */
}

/* 响应式设计 */
@media (max-width: 768px) {
  .floating-window {
    right: 10px;
    width: 150px;
  }
  
  .floating-window.left {
    left: 10px;
  }
  
  .floating-window.collapsed {
    width: 40px;
  }
}
</style>
